import AppListPage from "./AppListPage";

export default AppListPage;